import { SET_REVIEWS } from '../actions/types';

const setReviews = (state = [], action) => {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_REVIEWS:
				return action.payload;

			// no default
		}
	}

	return state;
};

export default setReviews;
